import { API_BASE_URL } from "../utils/adminHelpers";
import { requestJson } from "./instateamAdminApi";

export function getAdminPayrollOverview(token, query = {}) {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });

  const suffix = params.toString() ? `?${params.toString()}` : "";

  return requestJson(`/instateam/payroll/admin/overview${suffix}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function processAdminPayroll(token, payload) {
  return requestJson("/instateam/payroll/admin/process", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateAdminPayrollRecord(token, employeeId, payload) {
  return requestJson(`/instateam/payroll/admin/employee/${employeeId}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateAdminPayrollSettings(token, payload) {
  return requestJson("/instateam/payroll/admin/settings", {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function importAdminPayroll(token, rows) {
  return requestJson("/instateam/payroll/admin/import", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows }),
  });
}

export async function downloadAdminPayslip(token, payrollId) {
  const response = await fetch(
    `${API_BASE_URL}/instateam/payroll/admin/payslip/${payrollId}/download`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    let payload = { message: "Unable to download payslip." };

    try {
      payload = await response.json();
    } catch (error) {
      payload = { message: await response.text() };
    }

    const requestError = new Error(payload.message || "Unable to download payslip.");
    requestError.status = response.status;
    throw requestError;
  }

  const blob = await response.blob();
  const contentDisposition = response.headers.get("content-disposition") || "";
  const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

  return {
    blob,
    fileName: fileNameMatch?.[1] || `payslip-${payrollId}.html`,
  };
}
